<template>
  <a-modal
    ref="createModal"
    :title="'领料记录-'+ moTicketCode"
    :width="950"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
    :footer="null"
  >
    <a-spin :spinning="loading">
      <lsMetable
        class="editMaterial"
        :columns="detailCols"
        :data-list="detailList"
        :scroll="{ y:300 }"
        :IsEdit="false"
        :need-add="false"
        :pagination="detailPagination"
      >
        <template #requisitionCode="{ text, record }">
          <a href="javascript:;" @click="onShowDetail(record)">{{ text }}</a>
        </template>
      </lsMetable>
    </a-spin>
    <PickingModal ref="pickingModalRef" />
  </a-modal>
</template>

<script>
import { apiGetMesRequisitionCcPickIngLog } from '@/api/mes/workOrderManage/moTickets'
import PickingModal from '@/views/mes/workOrderManage/moTickets/components/picking-modal.vue'
export default {
  name: 'PickLogModal',
  components: {
    PickingModal
  },
  props: {
    mainBtnLoading: Boolean
  },
  data () {
    return {
      loading: false,
      visible: false,
      detailList: [],
      detailPagination: {
        pageSize: 10,
        current: 1
      },
      moTicketCode: '',
      detailCols: [
        { dataIndex: 'wipEntityName', title: '领料人', width: 150 },
        { dataIndex: 'requisitionTypeName', title: '领料类型', width: 150 },
        { dataIndex: 'statusName', title: '出库状态', width: 150 },
        { dataIndex: 'createTime', title: '领料申请时间', width: 150, customRender: (text) => text && this.$moment(text).format('YYYY-MM-DD HH:mm:ss') },
        {
          dataIndex: 'requisitionCode',
          title: '领料单号',
          width: 150,
          scopedSlots: { customRender: 'requisitionCode' }
        }
      ]
    }
  },
  methods: {
    show (moTicketCode, editIs) {
      this.editIs = !!editIs;
      this.visible = true;
      this.moTicketCode = moTicketCode;
      this.getDataList(moTicketCode);
    },
    onShowDetail(record) {
      const { requisitionCode } = record;
      this.$refs.pickingModalRef.show({ requisitionCode, title: '领料记录-' + requisitionCode }, false);
    },
    getDataList(moTicketCode) {
      this.detailList = [];
      this.loading = true;
      apiGetMesRequisitionCcPickIngLog({ moTicketCode }).then(res => {
        if(res.code === 200) {
          this.detailList = res.data || [];
        }else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 关闭模态框
    onClose () {
      this.visible = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.detailList = [];
    }
  }
}
</script>

<style  scoped lang="less">
</style>
